"use client";
import "../../../chunk-MMUBH76A.js";
import { useStore } from "../../stores/useStore.js";
const useClient = () => {
  const client = useStore((state) => state.client);
  return client;
};
export {
  useClient
};
